import Notifications from './Notifications';

const MESSAGES = {
  INVALID_SERVER_RESPONSE: 'Invalid Server Response',
  NOT_AUTHORIZED: 'You are not authorized to access this page, please login and try again.',
  TITLE: 'Unauthorized',
};

export default class AuthResponse {
  /**
   *
   * @param res
   * @param dispatch
   * @param commit
   * @returns {boolean|Promise}
   */
  static async validate(res, { dispatch = null, commit = null, rootState = null }) {
    if (!AuthResponse.isValid(res, dispatch)) {
      return false;
    }

    if (commit && (res.status === 404 || res.status === 500)) {
      commit('reset');
    }

    if (res.status === 400) {
      commit('ui/setHasErrors', true, { root: true });
    } else {
      commit('ui/setHasErrors', false, { root: true });
    }

    const response = await res.json();

    if (!response) {
      return false;
    }

    if (!rootState.ui.hasErrors) {
      return response;
    }

    if (response.detail) {
      // commit('ui/addError', response.detail, { root: true });
      Notifications.error(response.detail);
      return false;
    }

    if (Array.isArray(response)) {
      const messages = response.map(item => {
        if (item.message) {
          return item.message;
        }
      }).join('<br />');
      Notifications.error(messages);
      return false;
    }

    return response;
  }

  static validateDelete(res, dispatch) {
    if (AuthResponse.isValid(res, dispatch)) {
      return false;
    }

    if (res.status !== 204) {
      throw new Error(res.statusText);
    }
  }

  static isValid(res, dispatch) {
    if (!res || !res.status) {
      Notifications.error(
        MESSAGES.INVALID_SERVER_RESPONSE,
        () => dispatch('administrator/me/logout', {}, { root: true }),
        MESSAGES.TITLE
      );
      return false;
    }

    switch (res.status) {
      case 401: // Unauthorized
      case 403: // Forbidden
        Notifications.error(
          res.statusText || MESSAGES.NOT_AUTHORIZED,
          () => dispatch('administrator/me/logout', {}, { root: true }),
          MESSAGES.TITLE
        );
        return false;
    }

    return true;
  }
}
